export enum UserRequestStatus {
    Pending = 1,
    Approved = 2,
    Blocked = 3
}
